import type { SummaryTag } from '../../../lib/aiJobSummary';

/** Two or three tiny tags on a list row: what needs the human before opening the job. */
export default function SummaryTags({ tags, style }: { tags: SummaryTag[]; style?: React.CSSProperties }) {
  if (tags.length === 0) return null;
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap', ...style }}>
      {tags.map((tag) => (
        <span
          key={tag.label}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            height: '16px',
            // 1px of top padding, not symmetric: at 9px the font's own box is
            // taller than the line box, so pure centring still reads high.
            padding: '1px 6px 0',
            borderRadius: 'var(--radius-pill)',
            fontFamily: 'var(--font-mono)',
            fontSize: '9px',
            // See Badge: uppercase in a normal line box reads high.
            lineHeight: 1,
            letterSpacing: '0.06em',
            textTransform: 'uppercase',
            whiteSpace: 'nowrap',
            background:
              tag.tone === 'accent' ? 'var(--accent-soft)' : tag.tone === 'warn' ? 'var(--status-warn-soft)' : 'var(--surface-raised)',
            color: tag.tone === 'accent' ? 'var(--accent-text)' : tag.tone === 'warn' ? 'var(--status-warn)' : 'var(--text-faint)',
            border: tag.tone === 'neutral' ? '1px solid var(--border-hairline)' : '1px solid transparent',
          }}
        >
          {tag.label}
        </span>
      ))}
    </span>
  );
}
